<template>
  <div class="container">
    <v-alert
      text
      prominent
      type="success"
    >
      <v-row
        align="center"
        no-gutters
      >
        <v-col class="grow">
          ログアウトしました。
        </v-col>
      </v-row>
    </v-alert>
  </div>
</template>

<script>
import store from "@/store/index.js"

export default {
  name: "Logout",

  data: () => ({
    //
  }),

  methods: {
    //
  },

  mounted() {
    store.dispatch("clearLoginInfo")
  },
};
</script>